import React from 'react';
import { useTranslation } from 'react-i18next';
import classes from './Success.module.scss';

import { getEnv } from '@config';

const { publicPath } = getEnv();

const Success = () => {
  const { t } = useTranslation();
  return (
    <div className={classes.success}>
      <img className={classes.image} src={`${publicPath}/check.svg`} alt="success" />
      <p className={classes.text}>
        {t('Onboarding.MerchantOnboarding.documentationForm.successUpload')}
      </p>
    </div>
  );
};

export default Success;
